import { create } from 'zustand';

import type { KitMessage } from '@/shared/chat/components';

export type AssistantConversationSummary = {
  id: string;
  title: string;
  updatedAt: number;
};

export type StoredConversation = AssistantConversationSummary & {
  messages: KitMessage[];
};

type AssistantChatState = {
  conversationId: string | undefined;
  conversationsById: Record<string, StoredConversation>;
  messages: KitMessage[];
  setConversationId: (id: string | undefined) => void;
  setConversationsById: (
    value:
      | Record<string, StoredConversation>
      | ((
          prev: Record<string, StoredConversation>
        ) => Record<string, StoredConversation>)
  ) => void;
  setMessages: (
    value: KitMessage[] | ((prev: KitMessage[]) => KitMessage[])
  ) => void;
};

/**
 * Session-scoped assistant transcript. Survives sidebar close/reopen
 * (AssistantPanel unmount) until a full page reload.
 */
export const useAssistantChatStore = create<AssistantChatState>((set, get) => ({
  conversationId: undefined,
  conversationsById: {},
  messages: [],
  setConversationId: (conversationId) => set({ conversationId }),
  setConversationsById: (value) =>
    set({
      conversationsById:
        typeof value === 'function' ? value(get().conversationsById) : value,
    }),
  setMessages: (value) =>
    set({
      messages: typeof value === 'function' ? value(get().messages) : value,
    }),
}));
